export enum DeltaPatientType {
    OPD = 1,
    IPD = 2,
    ER = 3,
    ICU = 4
}